"use client";
import {
  Box,
  Typography,
  Grid,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import WorkIcon from "@mui/icons-material/Work";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import { motion } from "framer-motion";

export default function HowItWorks() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const steps = [
    {
      icon: <EmailIcon sx={{ fontSize: 32 }} />,
      title: "Personalized Problem Statement",
      description: "Identify a unique challenge in your educational context.",
    },
    {
      icon: <WorkIcon sx={{ fontSize: 32 }} />,
      title: "AI-Built Proposal",
      description:
        "Leverage AI tools to generate an initial solution proposal.",
    },
    {
      icon: <SearchIcon sx={{ fontSize: 32 }} />,
      title: "Critique & Analysis",
      description: "Critically evaluate the AI-generated proposal.",
    },
    {
      icon: <EditIcon sx={{ fontSize: 32 }} />,
      title: "Educator-Refined Proposal",
      description: "Refine and improve the proposal based on your expertise.",
    },
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: "#fff" }} id="how-it-works">
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{
            color: "primary.main",
            fontWeight: 500,
            mb: 6,
          }}
        >
          How It Works
        </Typography>

        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "primary.main",
                      mb: 2,
                    }}
                  >
                    {step.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    component="h3"
                    align="center"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      color: "text.primary",
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    sx={{ color: "text.secondary" }}
                  >
                    {step.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
